"use client";
import { Button } from "@/components/shared/ui/button"
import useCalStore from "@/store/useCalStore"
import { useEffect } from "react"
import { Loader2 } from "lucide-react"

const Consultation = ({ buttonText }: { buttonText?: string }) => {
    const { handleScheduleClick, getAdminCalUser, isLoading, error, adminCalUser } = useCalStore()

    useEffect(() => {
        getAdminCalUser()
    }, [])

    if (error) {
        return null
    }

    return (
        <div className="flex flex-col items-center">
            <Button 
                onClick={() => handleScheduleClick()} 
                variant="sub_primary" 
                size="lg" 
                className="px-16 py-6 rounded-3xl"
                disabled={isLoading || !adminCalUser}
            >
                {isLoading ? (
                    <Loader2 className="h-5 w-5 animate-spin" />
                ) : (
                    buttonText || "Book a Consultation"
                )}
            </Button>
        </div>
    )
}

export default Consultation